import { isValidEmail } from '@helpers';
import type { OnboardingWizardSubmitRequest } from '@api/domain/types';

import { DEFAULT_ROLE, OTHER_PREFIX, OTHER_VALUE } from '@components/tenantStatus/onboardingWizard/constants';
import type { WizardFormState } from '@components/tenantStatus/onboardingWizard/types';

export const isOtherSelected = (selected: string[]): boolean => selected.includes(OTHER_VALUE);

export const getInitialForm = (): WizardFormState => ({
  machines: { numberOfMachines: 0, selectedControls: [], otherText: '' },
  erp: { selectedErp: null, whichOneText: '' },
  goals: { selectedGoals: [], otherText: '', tellUsMore: '' },
  team: { members: [{ email: '', role: DEFAULT_ROLE }] },
});

export const buildOtherEntries = (selected: string[], otherText: string): string[] => {
  const without = selected.filter((v) => v !== OTHER_VALUE);
  if (!selected.includes(OTHER_VALUE)) return without;
  const trimmed = otherText.trim();
  return [...without, trimmed ? `${OTHER_PREFIX}${trimmed}` : OTHER_VALUE];
};

export const buildErpName = (selectedErp: string | null, whichOneText: string): string | null => {
  const trimmed = whichOneText.trim();
  if (selectedErp === OTHER_VALUE) return trimmed ? `${OTHER_PREFIX}${trimmed}` : OTHER_VALUE;
  if (selectedErp) return selectedErp;
  return trimmed || null;
};

export const buildPayload = (form: WizardFormState): OnboardingWizardSubmitRequest => {
  const targetsBase = buildOtherEntries(form.goals.selectedGoals, form.goals.otherText);
  const tellUsMoreTrim = form.goals.tellUsMore.trim();
  return {
    name: 'Onboarding',
    steps: [
      {
        $type: 'machineDetails',
        sequenceNumber: 1,
        numberOfMachines: form.machines.numberOfMachines,
        machineControls: buildOtherEntries(form.machines.selectedControls, form.machines.otherText),
      },
      {
        $type: 'erpDetails',
        sequenceNumber: 2,
        erpName: buildErpName(form.erp.selectedErp, form.erp.whichOneText),
      },
      {
        $type: 'targetDetails',
        sequenceNumber: 3,
        targets: tellUsMoreTrim ? [...targetsBase, `${OTHER_PREFIX}${tellUsMoreTrim}`] : targetsBase,
      },
      {
        $type: 'userInviteDetails',
        sequenceNumber: 4,
        userInvites: form.team.members
          .map((m) => ({ email: m.email.trim(), role: m.role }))
          .filter((m) => m.email.length > 0 && isValidEmail(m.email)),
      },
    ],
  };
};
